module.exports = __webpack_public_path__ + "img/21600.8c305e37.jpg";